module.exports = __webpack_public_path__ + "img/pool-icon-community.9878a08b.svg";